import api from "../axios";
import baseUrl from "../baseUrl";

export default {
  // 获取企业信息
  get() {
    return api.get(baseUrl + 'api/enterprise/business/info/get');
  },
  // 获取营业执照
  getLicense() {
    return api.get(baseUrl + `api/enterprise/business/licence/get`)
  },
  getLogo() {
    return api.get(baseUrl + `api/enterprise/business/pic/get/logo_image`)
  },
  // 上传营业执照或者带有企业名称的办公环境照片
  uploadLicense(params) {
    return api.post(baseUrl + "api/enterprise/business/pic/add", params);
  },
  // 添加补充信息
  add(params) {
    return api.post(baseUrl + "api/enterprise/business/info/add", params);
  },
  // 更新补充信息
  update(params) {
    return api.post(baseUrl + "api/enterprise/business/info/update", params);
  },
}